//Moayad: note names must be max 50 chars

export enum SalesBuzzParams {

  //Company info
  CompanyArabicName = 28,
  AutoAllocatePaymentByInvoiceDimensions = 6330,
  CompanyEnglishName = 29,
  //General sales
  DefaultReturnbinlocation = 8204,
  MandatoryPhoto = 6387,
  BackOfficeDBServer = 6162,
  DonotValidateInvBalanceForEveryTrx = 6191,
  PriceCodeMapping = 316,
  OrderItemsByCode = 320,
  ItemNameDisplayDirection = 350,
  RecommendOrderAllocationByVehicleStock = 8173,
  LegacyItemAttID = 371,
  ItemDisplayCriteria = 318,
  Remainfestreturnreason = 6424,
  CannotFinishvisitwithoutputastatuforalldeliverables = 6425,
  NoSetVehicleDriverOnAllocationOrders = 6438,//Ahmed Kotb 20151018
  UsepannedPayementMethodonPromotionCalculations = 6439,//Ahmed Kotb 20151019
  AlwaysDisplaycashpaymentmethod = 6426,
  ItemBatchAutoReserve = 3020,
  MakeBatchIDFieldInExpiryScreenIsComboBox = 357,
  ExpiryDateBehavior = 358,
  EnableAutoReplenishment = 359,
  FreeItemsCalculationMethod = 512,
  PictureResolutionWidth = 372,
  PictureResolutionHeight = 373,
  UploadedPhotosDirectory = 374,
  PhotosURL = 6389,
  ShowCustomerTime = 80,
  ShowAllUOMs = 3005,
  EnableBdf = 73,
  StopCustomer = 600,
  EnableQuestionnaireHistory = 74,
  LargeUOM = 81,
  SmallUOM = 3004,
  DefaultUOM = 1011,
  EnableFixedDiscountPerLine = 84,
  DefaultPriceList = 6080,
  ItemTypeCode = 377,
  SetQtyDecimalPlacesFromUOMRoundFactor = 6150,
  MandCustFields = 6171,
  //Visit
  SkipDistributionCheck = 4,
  SkipMerchandizingCheck = 5,
  CustomerMerchTypeAffective = 41,
  SkipPrint = 60,
  BarcodeToStartVisit = 90,
  ReadEncryptedBarcode = 342,
  RecordDistributionOfExpiryCheck = 321,
  MaxOutOrderVisits = 322,
  Disablemovingcustomerwithbalancefromjp = 6139,
  MaxOutJourneyPlanVisits = 2,
  StepsCode = 72,
  MerchSteps = 5005,
  DisableDuplicateVisitOrders = 6006,
  DisplayCustomerID = 6129,
  //Transfer Request
  TransferRequestMaximumValue = 344,
  TransferRequestPriceCode = 345,
  //Sales
  EnableRecordingExpiryFromOrderScreen = 337,
  ValidateOrderCustomerBranchCreditLimit = 6407,
  HideIncludedTaxes = 6308,
  AllowOverandUnderDeliveryinDispatching = 6306,//    PreventDeliverypersontodelivermorethanwantedqty = 6306,
  EnableSalesOrderCutReasons = 317,
  EnableCashDiscountWithDate = 349,
  GiveFreeItemEvenIfQuantityMoreThanStock = 356,
  AddReturnToExpiry = 375,
  ShowQtyForEachCustomer = 376,
  ShipmentNoAndDistributionOfficerMandatory = 3033,
  ChequeEffectCustomerBalance = 3021,
  EnableShifting = 3022,
  EnableCheckForTransactionBeforeDownload = 3023,
  EnablePostingPromotionsToSeparateGLAccounts = 2073,
  CheckDueDateCanSurpassInvoiceDueDate = 382,
  CheckDueDateFixedToCurrentDate = 383,
  IsManualInvoiceNoMandatory = 7319,
  //IgnoreCreditLimitIfOrderPlannedPaymentMethodCash = 390,//cancelled use 6045 instead
  CalculateCashDiscountOnCheckPayment = 5000,
  DeductCashDiscountFromInvoiceTotal = 5001,
  AllowAutoCashPaymentOverCreditLimitValue = 5020,
  AllowOrdersOverCustomerCreditLimit = 6022,
  TransferRequestRequiresSupervisorApproval = 6032,
  PaymentCollectionRequiresSettlement = 6033,
  UsePaymentMethodInCustomerCreditLimitCheck = 6045,
  NetWeightUOM = 6051,
  ServerType = 6167,
  GrossWeightUOM = 6052,
  CalculateSalesPriceByOrderDeliveryDate = 6120,
  GenerateAutoInvoicesAndReturnsOnDayClose = 6110,
  SalesmanAuthunticationRequestAfterDayClose = 6198,
  NoReserveQtyOnConfirmSalesOrder = 6124,
  DisableReturnSerialisedItemsNotInCustomerPreviousInvoices = 6153,
  ValidateCheckPaymentByCheckReader = 6345,
  InterfaceImportIgnoreChangedStatus = 6372,
  //Return
  EnablesRecordingReturns = 338,
  RetrnPriceCode = 343,
  CalculatePromotionsOnReturns = 348,
  AllowDaysToReturnItemsBeforeExpiryDate = 353,
  AllowDaysToReturnItemsAfterExpiryDate = 354,
  DefaultMaxAllowedQuantityToReturn = 355,
  ReturnCostWhenItemCostIsZero = 3040,
  //added by ghada raouf 7-05-2014
  EnablePurchaseOrderQuantityChangeReason = 6311,

  //Wholesale Options 
  EnableManualDiscountOnItemWholesale = 56,
  EnableManualDiscountOnInvoiceWholesale = 57,
  EnableChequeWholesale = 58,
  EnableCreditWholesale = 59,
  MandatoryStockCheck = 71,
  DisplayPromotionsWhileTakingOrders = 53,
  //Retail Options 
  EnableManualDiscountOnItemRetail = 61,
  EnableManualDiscountOnInvoiceRetail = 62,
  EnableChequeRetail = 63,
  EnableCreditRetail = 64,
  ShowPreviousQuestionnaireResults = 74,
  ShowPaymentReports = 79,
  EnableInvoiceStop = 82,
  ShowSuggestedValues = 75,
  //Printing options 
  UseItemLongName = 91,
  ShahiniLayout = 6396,
  DateRangeforAcceptingPDATransactions = 6398,
  PrintWithoutSerialAndValueAfterTax = 1001,
  PrintOldFormat = 1002,
  ViewDiscountsDetails = 1005,
  PrinterType = 1007,
  COMPortNo = 1006,
  EffectivePromotionsLevelsInPrices = 1004,
  WaitingPrintingPeriodMillisecond = 1003,
  PublicPriceCode = 1008,
  UseNewPrintingFramework = 1009,
  NamesPrintingLanguage = 1010,
  InvoiceLayout = 1012,
  PrintItemNumberInInvoice = 1013,
  ShowPrintButtonOfpreviousOrders = 35,
  PrintInvoice1stHeader = 76,
  PrintInvoice2ndHeader = 77,
  PrintInvoiceFooter = 78,
  PrintItemNameOnly = 6081,
  Enableprintingproformainvoiceorreturn = 6305,
  //Working Months 
  Jan = 324,
  Feb = 325,
  Mar = 326,
  Apr = 327,
  May = 328,
  Jun = 329,
  July = 330,
  Aug = 331,
  Sept = 332,
  Oct = 333,
  Nov = 334,
  Dec = 335,
  //Invoice Columns 
  InvoiceColumnsOrder = 341,
  //Salesman
  SalesmenSectorsManagement = 250,
  MaxRowCountInJourneyPlanManagement = 306,
  EnableMultiSalesman = 400,
  Deliverypersondeliveronly = 6133,
  DisableSalesmanCollection = 6134,
  DeliveryPersonCanNotChangePlannedPaymentMethod = 6130,
  IgnoreCachingItemsToReleasePDAMemory = 6346,
  // EnableMultiSalesmanSameCustomerAndSector = 319,
  GettingTargetActuals = 410,
  CalculatePromotionsForWohleSaleSalesmen = 513,
  AllowSalesmenToChangeWarehouse = 5011,
  AllowSalesmenToChooseStaff = 5012,
  //Fleet
  ActivateEnteringVehicleData = 310,
  FilterCustomersInJourneyPlanOnSalesman = 6182,
  LockProgramToEnterKMOdometer = 311,
  FeetControlServer = 312,
  FeetControlDatabase = 313,
  FleetUsername = 314,
  FleetPassword = 315,
  Validateontheplateno = 6077,
  DayOpeningtime = 6076,
  PreventDeliverypersontodelivermorethanwantedqty = 6306,
  //Synchronization 
  KeepDatabaseWhenSynchronizing = 346,
  MaxNumberOfLinesBeforeResync = 347,
  FullSyncBeforeVisit = 351,
  UploadTransactionsAfterVisit = 352,
  UploadTransactionsAfterDayClose = 7236,
  IgnoreUploadPreviousInvoices = 339,
  IgnoreDownloadCustomerBalance = 340,
  MessagesAppearToSalesmanAfterSync = 336,
  BackOfficeURL = 363,
  DirectTransferRole = 378,
  ServerUpdaterVersion = 379,
  ServerCabFileVersion = 380,
  ForceLogoDownload = 381,
  SyncBufferSize = 3006,
  IgnoreSyncErrors = 3030,
  //GPS
  EnableSalesmanTrackingusingGPS = 3000,
  MinSatellitesForGpsTracking = 3001,
  MinTimeToRecordGpsLocation = 3002,
  MindistancetorecordGPSlocation = 3003,
  GPSDisplay = 3010,
  DefaultErrorRadius = 368,
  ProofofVisit = 369,
  MaxVisitswithoutproof = 370,
  GPSFilterRadius = 6082,
  UploadPaymentsToDeliveryAndCollectionScreen = 6192,
  //ERP Integration Options 
  Erp = 2001,
  AutoPaymentCreation = 3045,
  AutoPaymentJournalType = 3046,
  SalesBuzzIntegrationMode = 6125,//thick = 1, thin = null or zero
  PutthedescriptionofthepromotioninsteadofHeaderLineId = 6136,

  //Infinity ERP
  InfinityDatabase = 100,
  ToImportDatabase = 101,
  InfinityEnableBUID = 102,
  EnableInvoiceupload = 2030,
  InfinityCashCycleId = 66,//CashTransactionCycle
  InfinityCheckCycleId = 67,
  CreditCardPaymentJournalId = 6118,
  InfinityTrxTypeIdOfTransferRequest = 360,
  NoUploadInvoicesAndTheirPayment = 2030,
  //Dynamics AX ERP
  AxDB = 100,
  CompanyCode = 2002,
  AxBaseUOMCode = 2003,
  AxTransferDefaultJournalNameID = 2004,
  AXUploadInvoicesToAXAndSyncWarehouse = 2065,
  AXExcludePresalesFromAXIntegration = 2071,
  AXGetQuantityLoaded = 2072,
  DisableMSAXBatchSupport = 2074,
  AllowDownloadingLineDiscountToSalesBuzz = 3007,
  SupplementaryItemConditionTypeGeneral = 3008,
  SupplementaryItemConditionTypeCustomerCriteria = 3009,
  FilterSalesmanInAXIntegration = 6095,
  AXPartition = 6122,
  Showreceivedquantityfromtransferorder = 6186,
  //RoadNet Ahmed Kotb
  RoadNetIntegration = 6358,
  ConfigUtilityRequestSecurity = 6354,
  Scenario = 6359,

  //Oracle EBS
  OracleTNSName = 2005,
  OracleDBUserName = 2006,
  OracleDBPassword = 2007,
  OracleOrganizationID = 2008,
  OracleLastSynchronizationDate = 2009,
  OracleOrderTypeID = 2010,
  OracleLineTypeId = 2011,
  UseOPMInventory = 2012,
  OPMMainWarehousecode = 2016,
  Languagefiltercode = 2013,
  Countryfiltercode = 2014,
  SendSMStoOracle = 6404,
  Itemfilterwherecondition = 2015,
  OracleEBSUserID = 2017,
  ResponsibilityID = 2018,
  ResponsibilityAppID = 2019,
  ReceiptmethodidforCash = 2020,
  ReceiptmethodidforCheck = 2021,
  ReceiptMethodIDForCreditCard = 6442,
  OracleReturnTypeID = 2022,
  OracleReturnLineTypeID = 2023,
  OracleReturnReasonCode = 2024,
  UseConversionrate = 2025,
  Autocreateinvoice = 2026,
  Processreturns = 2027,
  InventoryLocationIdToReceiveReturns = 2028,
  SubInventoryCodeToReceiveReturns = 2029,
  SubinventoryCodeForInvTransactions = 2064,
  CustomizationKey = 2062,
  OracleTrxsOrganizationId = 2067,
  OraclePriceListsCustomFilter = 2068,
  OracleWarehousesCustomFilter = 2069,
  ImportOracleOrdersCutoffDate = 2070,
  // ItemIDForOracleIntegration = 2098,
  ImportOracleOpenOrdersCutoffDate = 2075,
  TransactionORGIdForUpload = 2076,
  GetCustomerGeographicInfo = 2077,
  BrandCategorySet = 2078,
  MasterBrandCategorySet = 2079,
  UploadOrderOrInvoice = 2080,
  OracleDiscountUpload = 2081,
  SummarizeOrders = 2082,
  UploadTransfers = 2083,
  DriversCategory = 2084,
  HelpersCategory = 2085,
  UploadPayments = 5008,
  InvIssueTrxTypeID = 2088,
  InvReceiptTrxTypeID = 2089,
  CashInvoiceTrxTypeName = 2090,
  CreditInvoiceTrxTypeName = 2091,
  CreditMemoTrxTypeName = 2092,
  DistributionAccountId = 2093,
  UploadInvoiceForCreditPayments = 2094,
  MemoLineId = 2095,
  InvoiceTrxTypeOfCreditPayments = 2096,
  UploadUnloadingTransactions = 2097,
  UploadStaff = 2086,
  OracleCustomersFilter = 2087,
  //Hussein 
  DefaultPaymentTerm = 6009,
  DefaultTermBranch = 6010,
  //Hussein 
  IncludeSiteNameWithCustomerName = 6035,
  UploadSubInventoryWithSalesOrder = 6037,
  LoadOutstandingInvoices = 6038,
  SalesmanForExtraInvoice = 6056,
  LoadMainCustomerAttribute = 6066,
  CustomersCategoryCode = 6067,
  //ayman 
  PostCreditDebitMemoToHH = 6147,


  //Great Plains
  GreatPlainsDatabase = 2031,
  GreatPlainsApplicationDatabase = 2032,
  PricingMode = 6016,
  UOMConversion = 6017,
  ItemMasterBrand = 6018,
  PaymentcashbookID = 6019,
  RunReplicationEvery = 6083,
  //SAP
  SapDB = 2033,
  SapMANDT = 2034,
  SapSchema = 2035,
  SapDeliveryPlantToFilterHH_IC_Warehouse = 2036,
  SapCompanyCodeToFilterHH_BS_BankDefs = 2037,
  SapKTOKD = 2038,
  SPART_SalesDivisionToFilterHH_Customer = 2039,
  VKORG_SalesOrganization = 2040,
  VTWEG_DistributionChannel = 2041,
  NATION_Nation = 2042,
  ALAND_CustomerCountry = 2043,
  TATYP_TaxApplicableonCustomer = 2044,
  KKBER_CreditControlArea = 2045,
  ItemPriceList = 2046,
  FKART = 2055,
  WBSTK = 2056,
  MARA_MTART = 2057,
  Sapsecondlanguage = 2058,
  Sapitemshortdescriptionlanguage = 2059,
  UploadTransfer = 2060,
  //modified by Ghada Raouf [2013-11-07]
  DefaultCurrency = 2061,//previously called CurrencyCodeForPayments
  DistributerModel = 5014,
  IgnoreTaxes = 2063,
  ReturnDocumentType = 5015,
  MultiSalesArea = 6036,
  SAPFirstLanguage = 6042,
  SupervisorPartnerFunctionKey = 6043,
  SAPBankDefinitionFilter = 6046,
  BankCountry = 6057,
  //Hatem Additional SAP Params 
  SkipRebate = 6053,
  GetOpenInvoices = 6054,
  OpenInvoicesDocumentType = 6055,
  //Sherine Sabbour additional SAP Params 2012-07-02
  BranchesMapping = 6059,
  DisableGeographyMapping = 6060,
  GeneralCondTable = 6061,
  SpecificCondTable = 6062,
  SalesmanCatFilter = 6063,
  CustAccGrpFilter = 6064,
  MaterialTypeFilter = 6065,
  //Shaimaa Moustafa 29072012 -- SAP --Salesman
  DisableSalesmanSupervisorMapping = 6072,
  TaxConditionTable = 6073,
  CustomerTaxClassification = 6075,
  TaxSalesOrganization = 6074,
  //Sherine Sabbour additional SAP Params 2012-08-28
  SalesmenMapping = 6078,
  GroupingBoOrders = 6079,
  //Sherine Sabbour additional SAP Params 2012-08-29
  SalesmanStockMapping = 6084,
  //Sherine Sabbour additional SAP Params 2012-11-06
  SubBrandMapping = 6096,
  ClassCharCode = 6097,
  PostCreditDebitMemoToSAP = 6107,
  SBWrongBalancesJT = 6131,
  SBOpenBalancesJT = 6132,
  //Pre-Order 2013-11-13
  PreSaleOrderDocumenttype = 6197,
  PreSaleReturnDocumenttype = 6199,

  VehiclePartnerFunction = 6200,
  DriverPartnerFunction = 6201,
  VehicleAccountGroup = 6202,
  DriverAccountGroup = 6203,//changed to Driver Filter 
  VehicleType = 6204,
  SalesmanPartnerFunction = 6208,
  AdjustCalculationofTaxesWithDiscounts = 6333,


  //Synchronization Params
  SynchURL = 363,
  WiFiSyncURL = 366,
  GPRSSyncURL = 367,
  SynchUser = 364,
  SynchPassword = 365,
  DomainServiceOpenTimeout = 6001,
  DomainServiceCloseTimeout = 6002,
  DomainServiceSendTimeout = 6003,
  DomainServiceReceiveTimeout = 6004,
  EncryptPDAResponse = 6005,
  ActiveSyncPassword = 384,
  TransfersalesmanwithoutCreditLimitexceedingcheck = 3051,
  AllowSalesManTransferorTerminatewithpendingcredit = 3050,
  NewBOURL = 3024,
  InDebugMode = 5050,
  ShippingAllocationUOM = 5002,
  ShippingUnitName = 6026,
  ShippingUnitNameArabic = 6027,
  PrimaryShippingUOM = 6195,
  SecondaryShippingUOM = 6196,
  SecondShippingAllocationUOM = 6159,
  SecondShippingUnitOfMeasureName = 6160,
  SecondShippingUnitOfMeasureNameArabic = 6161,
  ThickModeUnDeliveredReasonslookup = 6128,
  NoTransferToDeliveryVehicleOnConfirm = 6041,
  RequireEntryOfManualInvoiceNumberOnPDA = 5003,
  DayClosingEnabled = 514,
  VerifyStockBeforeDayClosing = 5006,
  AutomaticUnloadUponDayClosing = 5007,
  WarehouseKeeperRole = 5009,
  Precision = 38,
  Unloadingtransactiontype = 6007,
  OracleVanSubInventoryType = 6008,
  EnablePeriodCheck = 6011,

  //Shaimaa Moustafa 22-02-2012
  MergeReplicationOptions = 6012,

  NoOfDaysToDeliver = 6013,
  EnableDayClosingwithoutTrx = 6014,
  SyncDateWithServer = 6015,
  //Eslam Mohamed
  DaysToDeliver = 6020,
  EnableCheckDelviery = 6021,
  ZeroTaxOnFreeItem = 6023,
  SalesmanConfirmDirectTransfer = 6024,
  ForceStaffSelection = 6028,
  //Ahmed Kotb
  EnforceOrderTargetDeliveryDateOnDispatching = 6117,
  RecalculatePricesOnConfirm = 6116,
  //Ahmed Hosam - Params for oracle integration
  BookPreSalesOrders = 6029,
  LoadWarehousebalance = 6030,
  MoveOrdersCutOffDate = 6031,
  EnableServiceToAllocateOpenOrder = 6047,//for eslam
  //Ahmed Saher
  EnableItemsOverStockNotification = 6039,
  DownloadCustomerGISInfo = 6048,
  UOMDisplayName = 6049,
  //Shaimaa Moustafa 10062012 -- Account Receivables -- Customer Definition
  EnableUniqueTelMobileElectricityLicense = 6050,
  DisplayCustomerType = 6068,
  DisplayCustomerCategory = 6069,
  DisplayDailyTarget = 6070,
  ForceVisitAtCustomerLocation = 6071,
  CustomerTypeMapping = 6085,
  SAPItemShortDescriptionSecondLanguage = 6086,
  // Added By : AHmed Amin   
  Disable_Keyboard_from_poppingup_automatically = 6090,
  //Nehad Hazem 4/10/2012
  RemoveZerosFromItemID = 6091,
  // Added by Ahmed Amin
  MasterDataCustomization = 6092,
  //Nehad Hazem 8/10/2012
  NumbersPrintingLanguage = 6093,
  MandatoryBillofLading = 6099,
  MandatoryShipmentNo = 6100,
  CollectionDifference = 6101,
  EnableCashCrossCheck = 6102,
  SettlementDifference = 6103,


  AddVisitPaymentPositiveVisitCalculation = 6098,
  AllowPartialPayments = 6104,
  LoadingitemsLargeUOMOnly = 6105,
  ValidateReturnValue = 6106,
  PrintLineTotalWithTax = 6108,
  DisplayConfirmationMessage = 6109,

  //TFS: 3553  Journey plan based on financial years
  JourneyPlanBasedOnFinancialYears = 6111,
  CheckPendingPaymentsBeforeTransferRequestApproval = 6119,

  AllowReverseinvoiceinsamedate = 6127,
  // Added by Samar
  DelayedUpdateForSalesmanItems = 6138,
  EnableSendingSMSAfterTransactions = 6141,
  SMSDefualtTemplateType = 6142,

  // Added by Samar [13-05-2013] - TFS task #[4786]
  ReturnFromUnsettledInvoicesOnly = 6143,
  ReturnPeriod = 6144,
  ReturnPeriodType = 6145,
  DayClosingTime = 6151,
  ChequeCalcTarget = 6146,
  RequireOpenDayToStartPdaActivity = 6152,

  DisablePromotionReCalculationUponConfirm = 6154,
  //Added By Samar [02-06-2013]
  ApplyRecordLevelSecurityOnReportManager = 6155,
  LoadSalesorderQuestionnairewithDefaultAnswers = 6156,
  EnableQuestionnaireonSalesOrder = 6157,
  ReturnsCannotExceedDebitCredit = 6158,
  AllowEnteringMonthlyPayment = 6140,

  ApproveSignatureBeforeConfirmSO = 6163,

  // Added by Samar Samy [21-07-2013]
  AllowReprintVerification = 6164,
  DeactivateReplenishmentInLoadRequest = 6165,
  VIOPApplicationName = 6166,
  EnableQuantityIncrementOnItemScan = 6168,
  ServerAndroidFileVersion = 6170,


  EnablePasswordContorolforBO = 6172,
  PasswordExpiryPeriodforBO = 6173,
  PasswordLengthforBO = 6174,
  PasswordStrengthforBO = 6175,
  passwordExpiryUOMforBO = 6176,
  EnablePasswordContorolforPDA = 6177,
  PasswordExpiryPeriodforPDA = 6178,
  PasswordLengthforPDA = 6179,
  PasswordStrengthforPDA = 6180,
  passwordExpiryUOMforPDA = 6181,
  RebatesJournalTypeID = 6183,
  RebatesCalculationPeriods = 6184,

  //  Added By Samar Samy [20-10-2013]
  // JoinUomWithItems = 6187,
  CustomerTaxConditionType = 6188,
  CustomerTaxConditionTable = 6189,
  ExcludeEffectofPromotionsInRebateCalculations = 6190,
  BUIDGovernorateReplicationMapping = 6194,
  //added by ghada raouf [2013-11-20]
  LoadMainWarehouseData = 6207,
  AllowretailsalesmantosynchronizewithoutdayClose = 6205,
  AllowDrivertosynchronizewithoutdayClose = 6206,
  OraclewarehouseSyncronization = 6212,
  //added by ghada raouf 2013-12-08
  NoCheckOnSalesOrderDates = 6209,
  //added by ghada raouf 2013-12-11
  UseMidPointRoundingAwayFromZero = 6210,

  MaxActiveReportsCapacity = 6213,
  CountOfReportstobeAutoDisposed = 6214,
  LazyloadpromotionItemcriteria = 6215,
  SSRSServerUrl = 6216,
  SSRSdbserver = 6217,
  SSRSdbname = 6218,
  SSRSdbuser = 6219,
  SSRSdbpassword = 6220,

  //ISCALA ERP integration -- Ahmed Fayed
  IScalaCompany = 6300,
  PaymentCashAccount = 6301,
  PaymentCreditAccount = 6302,
  //Ahmed Fayed 03-07-2014
  DisableUploadTransferToIScala = 6318,
  DisableUploadInvoiceToIScala = 6319,
  DisableUploadPaymentToIScala = 6320,
  DisableUploadOrderToIScala = 6321,
  PreSaleSalesmanTypeCondition = 6304,
  PresaleFreeItemCategory = 6307,
  EnableWholeSaleSalesmantoEditInOrder = 6309,
  DisableBarcodeAtPDA = 6310,
  PricingAttributeID = 6312,
  HelpersMandatoryInAllocation = 6313,
  DependOnSalesmanPLTypeWhileUploadingJournals = 6314,
  VansaleSalesmanTypeCondition = 6315,
  ProductAttributeID = 6316,
  SAPCustomaizationKey = 6094,
  BadExpiredReturnDocumentType = 6322,
  BadDamagedReturnDocumentType = 6323,
  SkipReturns = 6324,
  EnableSplittingReturns = 6325,
  BadSalesBuzzReturnReason = 6326,
  ReturnFreeItemCategory = 6327,
  EnableFilteringItemsbyPaymentMethod = 6211,
  CloseClientRoleID = 6329,
  ApplyPromotionsonReturnFromInvoiceOnly = 6317,
  ReplenishmentDocumentType = 6331,
  Timetotimeoutrequestinseconds = 6332,
  MaximumNoOfTrips = 6334,
  CloseClientBarcode = 6339,
  ItemsInTheInvoice = 6340,
  ItemsInCustomerStock = 6341,
  ItemsPurchasedHistory = 6342,
  PurchasesHistoryNumberOfDays = 6343,
  ActivatePotentialCustomerRequest = 6344,
  OverdueApprovedPaymentsDays = 6347,
  StockBalanceValues = 6348,
  PendingTransfer = 6349,
  PendingPayments = 6350,
  AllOutStandingDocuments = 6351,
  OverdueInvoicesOnly = 6352,
  DefaultCloseOrderReason = 6375,
  DefaultCloseReasonForOracle = 6408,
  DownloadCreditNotes = 6353,
  EnablePrePayment = 6355,
  EnforcePlannedPaymentMethod = 6356,
  AllowChangeUomInDispatchingDelivery = 6357,
  DisableloaditemsNotIncarstoreinmemory = 6360,
  CalculateTargetActualsforAllSoldItems = 6361,
  OrderTakerSuggestedValue = 6362,
  AddPendingTransactionOracleBalance = 6365,
  CreateReturnFromUndeliveredQty = 6366,
  DeliveryRejectionreasonformanifestorders = 6367,
  AllowEnterOdometerReadingPerEachVisit = 6368,
  MaxLengthofOdometerReading = 6369,
  EnableOnlineReturnfeature = 6370,
  ShowSalesmanCurrencyOnly = 6371,
  AcceptPaymentValueMoreThanInvoiceValue = 6373,
  ShowJourneyPlanCustomers = 6376,
  RoadNetRegion = 6377,
  SendingRoadNetBatchLimit = 7128,
  AutoSettleCustomerTransactionsByDate = 6378,
  Allowsplittingorder = 6379,
  NoCashDiscountInOpenTransactionEditing = 6381,
  AllowEditingPromotionOutcomeAfterActivation = 6380, // Added by Samar Samy 2015-04-29
  ExcludeCheckOnSalesmanBalance = 6382,
  Allowcancelvisit = 6383,
  Daysneededtoadjusttransactiondate = 6384,
  DownloadProfileClass = 6385,
  PointsExpiryDays = 6386,
  IgnoreCheckingPendingInventoryTransactionsOnOracle = 6388,
  PointingSystemCompanyBU = 6394,
  PointingSystemRedeemJournalTypeID = 6391,
  PointingSystemRedeemOffsetAccountID = 6392,
  SplitOrderAccordingToItemOrganization = 6390,
  CreateCreditMemoOnRedeem = 6397,
  FiltervisibilityStepByStockCheckItems = 6399,
  StockCheckItemInitiallyAppearsWithLastReceivedValues = 6400,
  AllowUploadTransfersWithoutDayClose = 6401,
  FirstPrimaryLanguage = 6402,
  SecondPrimaryLanguage = 6403,
  AndroidSyncServiceURL = 6409,
  SyncParsingMode = 6410,
  DisableLoginUsersWithTheSameUserName = 6411,
  SMTPHost = 6429,
  SMTPPort = 6430,
  SMTPDomain = 6431,
  SMTPLogin = 6432,
  SMTPPassword = 6433,
  SMTPUseSecuredConnection = 6434,
  EmailFrom = 6435,
  EmailTo = 6436,
  ERPServerType = 6088,
  CashJournalNumber = 6413,
  CashJournalZTableName = 6414,
  SupportBatchesOnReturn = 6415,
  SAPWebServiceURL = 6428,
  AXCustomizationKey = 6437,
  EnableCatchWeightCycle = 6440,
  CatchWeightUploadedOrdersUOM = 6441,
  CleanUpBackupDB = 6445,
  CustomerPlaceOrderOnceDaily = 6447,
  PreSaleSalesmanStockMapping = 6446,
  ValidateOnVehicleWeightBeforeTransferApproval = 6448,
  HidePayButtonInOutstandingInvoiceScreen = 6449,
  ShowSalesHistoryForSDS = 6444,
  SoldToPartyPartnerRole = 7001,
  ShipToPartyPartnerRole = 7002,
  SyncFileValidAge = 7007,
  SalesmanReturnLimitValidation = 6502,
  ReturnLimit = 6503,
  PricingCalculations = 7008,
  EnableChangingJPevenIfSalesmanHasOpenDay = 7009,
  VanVehicleType = 7004,
  VanPartnerFunction = 7005,
  UploadVehicleInSalesOrder = 7003,
  InternalSyncServiceURL = 7011,
  EnableBackgroundQRcode = 7012,
  UploadTransactionToSAPWithOpenDay = 6500,
  HidePriceAndOrderTotal = 7013,
  Multidistributionchannel = 7019,
  EnableReSyncCompression = 7025,
  EnableUploadCompression = 7520,
  MinimumCapacityNeededToConfirmAllocation = 7026,
  UploadPaymentsForSalesbuzzCustomers = 7027,
  CustomerCardAverageSales = 7029,
  UseHTMLPrintingLayout = 7031,
  ShowMSLItemsInInvoice = 7033,
  ShowMSLItemsInStockCheck = 7034,
  IgnoreUnloadingApproval = 7035,
  ARResponsibility = 7036,
  InvoiceNameinArabic = 7037,
  InvoiceNameInEnglish = 7038,
  EnablePrintingProFormaInvoiceOrReturnForVansale = 7016,
  UploadModifierToSalesOrders = 7042,
  UpdateItemTaxCodes = 7043,
  GetPromotionsintheSnapshot = 7044,
  ItemBalanceQTP = 7046,
  AllowVanorDrivertoexceedcustomercreditlimit = 6501,
  EnableInvoiceWithZeroPrice = 7023,
  EnableClosingDayTRX = 7048,
  EnableSendingBackendSMS = 7049,
  DefaultSenderID = 7050,
  ValidsendingTimeIntervalFrom = 7051,
  ValidsendingTimeIntervalTo = 7052,
  SMSWebServiceURL = 7053,
  CustomerMobilePhoneNumberMandatory = 7054,
  IsContractDetailsMandatory = 7000,
  DefaultAssetLocationType = 7045,
  ShowOrderExtraInfo = 7060,
  PONumberMandatory = 7058,
  MasterBrandMapping = 7056,
  ProgramConditionType = 7059,
  MapReturnReasonToItemCategory = 7055,
  CollectAllOutstandingInvoicesInTheJourneyPlan = 7061,
  EnablePOD = 7057,
  ForceStandardOracleIntegrationForNonDelivery = 7062,
  ConditionTypeForPromotions = 7063,
  PrintQtyUsingOneUOM = 7064,
  OnlineReturnDefaultReason = 7069,
  UploadJournals = 7065,
  UploadSalesOrders = 7066,
  UploadTaxes = 7067,
  UploadPrices = 7068,
  showPrintProformaButton = 7017,
  Distribution = 7071,
  DistributionCalculationPeriod = 7070,
  ImageDistributionQuestion = 7072,
  UseGPRounding = 7073,
  MediaFileswithoutupload = 7074,
  FreeItemConditionType = 7075,
  ItemsLimitInOrderScreen = 7028,
  ShowPrintProformaButton = 7017,
  EnableSettleCustHasSalesmanOpenDay = 7077,
  HandlingItemLeftZeros = 7079,
  UploadChequeJournals = 7129,
  KeepDatabaseWhenSynchronizing_Android = 7130,
  IgnoreErrorsDuringSynchronization_Android = 7131,
  HighlightPSKUItemsOnBeginning = 7132,
  AffectSalesmanBalanceOnPayment = 7133,
  LogFileSize = 7134,
  SyncServiceDebugLevel = 7136,
  POReturnReasonIsRequired = 7135,
  RecommendedQtyCalcType = 7137,
  ConsumptionFactor = 7138,
  IgnoreUnapprovedPayment = 7139,
  FirstItemFilter = 7144,
  SecondItemFilter = 7145,
  ShowItemFiltersInPortraitView = 7146,
  DashboardTargets = 7147,
  FieldBuzzApiUrl = 7150,
  EnableUpgradeCompressionBatching = 7151,
  UpgradeCompressionBatchSizeKB = 7152,
  GoogleMapAPIKey = 7153,
  ShowProgramPromotionInOrderSummery = 7154,
  EnableDynamicItemsFilter = 7155,
  DoNotGetOrderTypeFromERP = 7160,
  BoSyncUrlOverRide = 7161,
  VanLocation = 7163,
  CreateandPostPaymentforshortageinvoiceandreturns = 7142,
  DonnotCreateandPostPaymentforshortageinvoiceandreturns = 7553,
  EnablePaymentHeaderCollectedvalue = 7162,
  UploadInventoryTransaction = 7164,
  VATAuthority = 7165,
  ExciseAuthority = 7166,
  SSRSReportsFolder = 7167,
  Aging1 = 7168,
  UploadReturnWithReference = 7270,
  Aging2 = 7169,
  Aging3 = 7170,
  DocumentTypeZTableBasedOnCustomer = 7171,
  AssignBatchOnReturn = 7172,
  TaxCalcMethod = 7175,
  DeliveryVacationDay = 7176,
  LoadingRequestPrefix = 7177,
  UnLoadingPrefix = 7178,
  SalesOrderPrefix = 7179,
  SalesInvoicePrefix = 7180,
  ReturnOrderPrefix = 7181,
  ReturnInvoicePrefix = 7182,
  PaymentPrefix = 7183,
  LoadingPrefix = 7184,
  IgnoreTransferApproval = 7185,
  ItemsDisplayMethod = 7186,
  InventoryIssueTrxTypeIDForAssetInstallation = 7081,
  InventoryReceiptTrxIDForAssetWithdrawal = 7082,
  SAPConnectorPassword = 7187,
  SAPServerID = 7188,
  SAPSystemNumber = 7189,
  SAPUserName = 7190,
  SAPRouter = 7191,
  SAPSystemID = 7192,
  SendDiscountsToAXasMiscellaneousCharges = 7194,
  TransferApprovalRoundingMethod = 7197,
  TransferApprovalRoundingConversion = 7198,
  AndroidThemeColor = 7199,
  GetNoOfDaysToCalculateDailyAchievedPSKU = 7200,
  RequireReturnApproval = 7201,
  AddItemLocationFilter = 7195,
  PrimaryShippingUOMRounding = 7206,
  SecondaryShippingUOMRounding = 7207,
  NetWeightUOMRounding = 7208,
  DeliveryStatusReason = 7209,
  DefaultCashPaymentTerm = 7210,
  UploadAllSuccessfulTransaction = 7211,
  DefaultBlockDeliveryStatus = 7214,
  RndCondType = 7213,
  MinimumPaymentValue = 7203,
  ProformaFooter = 7204,
  DefaultBatchNo = 7215,
  AllowWholeSaleSalesmanToSynchronizeWithoutDayClose = 7216,
  SaveUnappliedPromotion = 7205,
  DefaultPricingProcedure = 7220,
  UploadFastCollectionPaymentstoOracle = 7221,
  ConfirmAllocationMoveOrders = 7222,
  UploadedPaymentsSeuquenceNumber = 7223,
  AllowThinModeCollection = 7226,
  //AllocateMoveOrder = 7227,
  DoNotAllowPartialQuota = 7230,
  Allowautotransfergenerationonsalesmanupload = 7218,
  Automatictransferrequestoptions = 7219,
  DomainName = 7217,
  VatNumber = 7229,
  OpenReturnFooter = 7231,
  UploadTaxestoERP = 7232,
  CheckERPStock = 7233,
  ReduceUploadedImageSizeInKB = 7234,
  ErrorRate = 7086,
  ContinueOnWrongCalculations = 7087,
  CompleteCycle = 7088,
  SalesBuzzOrderReason = 7089,
  ApplyFreeItem = 7090,
  ManualPromotionCalculations = 7091,
  ManualDiscountlConditionType = 7092,
  DiscountConditionType = 7093,
  FreeItemCategory = 7094,
  ZeroUPriceItemCategory = 7095,
  AssignBatchesForOrderLinesBeforeUploading = 7096,
  NumberOfDaysToGetBatchesIn = 7097,
  ConvertSoldUOM = 7098,
  UseSalesOrgAsPlant = 7099,
  SendPickingQuantity = 7100,
  CreateTransferOrderForDeliveryNote = 7101,
  WarehouseNumberForTransferOrderForDeliveryNote = 7102,
  SkipDeliveryStep = 7103,
  SkipPayment = 7104,
  uploadCollectorPaymentsOnly = 7105,
  SkipTransferRequest = 7106,
  BusinessTransaction = 7108,
  UnderpaymentBusinessTransaction = 7109,
  OverpaymentBusinessTransaction = 7110,
  CashJournalNumberl = 7111,
  ChequeBusinessTransaction = 7112,
  CashJournalClearing = 7113,
  ChequeCashJournalNumber = 7114,
  PODocumentType = 7115,
  TContinueOnWrongCalculations = 7117,
  PurchasingOrganization = 7118,
  PurchasingGroup = 7119,
  MaxDifferenceDays = 7120,
  NumberOfAddedDays = 7121,
  EnableDirectTransfer = 7122,
  EnableUploadUnloadingTrx = 7123,
  UploadDayClosing = 7124,
  UploadDayClosingCutOfDate = 7125,
  PickupTransferDocumentType = 7126,
  QualityReturnDocumentType = 7127,
  CustomerCategoriesMapping = 7235,
  TransferDocumentType = 7021,
  MultiPromotionConditionType = 7022,
  ContinueOnOutOfStockItemsOnDelivery = 7140,
  PaymentMapping = 7237,
  PaymentDocumentType = 7238,
  UploadTransactionWithFillupReference = 7020,
  DefaultStockCheckQty = 7240,
  OrderCeiling = 7251,
  OrderFreeItemConditionType = 7253,
  licenseNoMapping = 7254,
  NoDeliveryPriceRecalculation = 7242,
  ConvertUOMWithPriceCalc = 7245,
  UploadVehicleOdometerToERP = 7258,
  MapInvoiceAccountToBayer = 7228,
  PayerPartnerRole = 7260,
  EnableGpsMemoryRelease = 7263,
  PrimaryPrintingLanguage = 7246,
  SecondaryPrintingLanguage = 7247,
  PrintLayoutSubFolder = 7249,
  CanAllocateWithoutRoute = 7241,
  FilterSalesmanQuotaBySupervisor = 7256,
  GivingPointsOnPartialAchievingTarget = 7434,
  RemoveTransferApprovalIfSAPUploadingFailed = 7252,

  EnableAdvancedMerchandizingMode = 7277,
  ERPVersion = 7269,
  UploadOrderAfterDelivery = 7255,
  isOracleErp = 2001,
  UploadPresaleOrdertoAXafter = 7259,
  DisableValidatingEffectingOnInventoryBalances = 7268,

  ReportMangerlookupFilterIsmultiselect = 7275,
  AllowemptybarcodeandserialincustomerLocation = 7309,
  ShowBreakOption = 7272,
  ConsolidatedUOM = 7316,
  TripManagment = 7314,
  SettlementDateDefaultValue = 7313,
  DefaultSkipReason = 7322,
  TruckInventoryCheck = 7324,
  CreateReturnBillingReferenceTo = 7332,
  UploadManualPONumberInPresaleCycle = 7333,
  SalesEmployeePartnerFuncation = 7336,

  Includefreegoodsintargetscalculation = 7311,
  UploadTransferAsFillUpOrReservation = 7338,
  DaysToKeepClosedTrans = 7261,
  PriceCodeFilter = 7078,
  AllowSalesmanToWorkInMultipleDays = 7337,
  RouteIsmandatoryonSalesman = 7349,
  DisabledUploadTables = 7345,
  BlindingSystemStockInStockCount = 7350,
  IgnoreZeroappliedQuota = 7352,
  VerifyStockDayCloseSalesmanTypeFilter = 7340,
  StockCountInitialValue = 7354,
  SelfOrderMode = 7355,
  DefaultSalesman = 7356,
  PreventMultipleSalesmanOnSameVan = 7360,
  EPaymentJournalId = 7364,
  SyncFilesPath = 7373,
  RemoveWordBusinessPartner = 7362,
  RemoveWordPOSType = 7365,
  RankingGamification = 7533,
  MerchInvoiceNumberStringOrDigit = 7361,
  UploadPaymentByApprovalDate = 7366,
  OrderFilterNavigation = 7363,
  NewPriceUOM = 7379,
  RetailerTitle = 7383,
  PreSaleTitle = 7384,
  DeliveryTitle = 7385,
  ReceiptPrintLimit = 7388,
  OnPromotionTaxesMinValue = 7390,
  OnLineRequestCloseReason = 7394,
  ValidatePendingTransfersFromSAP = 7382,
  SAPNetTotalVariance = 7381,
  SalesmanType = 7396,
  SalesmanCorrectionJournalTypeID = 7389,
  DefaultAuthenticationMethod = 7397,
  UseSalesBuzzauthentication = 7398,
  UseActiveDirectoryAuthentication = 7399,
  UseSAML2SSO = 7400,
  SAMLIDPURLParameter = 7401,
  SAMLIDPLogoutURLParameter = 7402,
  SSRSDataSourceName = 7403,
  ApplyCheckCashDiscountMethod = 7405,
  SnapshotWebApplicationURL = 7274,
  LoadSalesOrderQuewithDefaultAnswers = 7408,
  PreventReLoadingTRXForDeliveryPersonOnTrip = 7407,
  DefaultReturnBatch = 7409,
  Recordpaymentatpointofactualpayment = 7041,
  CashierApprovalSpecifyRemittanceBankDetails = 7406,
  SyncLoadWait = 7411,
  DispatchingLoadingMode = 7410,
  TaxesIncludedinPromotionPrice = 7416,
  DefaultVendorId = 7418,
  CustomerAccountCreationSetId = 7419,
  PreventExtendExpiryDate = 7438,
  UploadTransactionWithOutGrouping = 7391,
  RemovePriceFromPriceCheck = 7425,
  CompanyReturnNo = 7426,
  RemoveTNamesFromLocationType = 7427,
  ShowOnlyItemsNeedReplenishment = 7428,
  ShowCommentFieldInPriceCheck = 7429,
  AddingFacingQuantity = 7430,
  EnablePointingSystemRequests = 7432,
  CustomerCreditLimitValidationLevel = 7433,
  LoadOutTransactionsAdditionalItemsCategory = 7367,
  UploadPendingTransfersFromSAP = 7435,
  EnableNewReturnTaxMethod = 7551,
  PresalePaymentDocumentType = 7431,
  outstandingdocumentNoMappingParam = 7525,
  EnableCheckingontheQuotaOnline = 7526,
  CustomerProfileBUIDLevel = 7386,
  MaxNumberOfOfflineInvoicesIssued = 7531,
  CommissionTargets = 7540,
  RebateRounding = 7538,
  SAPCreditLimitMapping = 7544,
  EPaymentPushOrPullMode = 7439,
  RegistrationCodeForEPayment = 7532,
  EPaymentConfigurationURL = 7549,
  CalculateFreeGoodsOptionsBy = 7557,
  UseReportManagerConnectionString = 7597,
  CashDropOffJournalId = 7566,
  FawryMinAmount = 7567,
  FawryMaxAmount = 7568,
  SAPPrecisionValue = 7378,
  DefaultItemsView = 7584,
  PaymentApprovalAllowsOnlyFullPayments = 7585,
  CommissionCalculationMethod = 7587,
  OnlineImageProcessingClientId = 7576,
  OnlineImageProcessingUsername = 7577,
  OnlineImageProcessingPassword = 7578,
  OnlineImageProcessingSurveyId = 7579,
  OnlineImageProcessingAssignmentId = 7580,
  OnlineImageProcessingActivityCategoryId = 7581,
  OnlineImageProcessingSkuGroupId = 7582,
  OnlineImageProcessingDisplayType = 7583,
  OnlineImageProcessingScope = 7589,
  OnlineImageProcessingBaseURL = 7590,
  OnlineImageProcessingDefaultCustomer = 7591,
  PrintingAllOnlineReturns = 7594,
  SAPDefaultReturnBatch = 7593,
  ERP_USER = 7559,
  ERP_PASS = 7560,
  ERP_COMPANY = 7561,
  ERP_URL = 7562,
  ERP_TIMEOUT = 7563,
  ERP_ReportsPath = 7588,
  ExcludeParkeddocfromOutstanding = 7598,

  PresalesIndicator = 7599,
  VanIndicator = 7600,
  AllowItemRanking = 7565,
  //SAP B1 integration
  SAPB1InvoiceSeries = 7535,
  SAPB1ReturnSeries = 7541,
  SAPB1TransferRequestSeries = 7542,
  SAPB1PaymentsSeries = 7543,
  SAPB1CashGLAccount = 7546,
  SAPB1checkGLAccount = 7547,
  SAPB1CashPaymentunderCollectionGL = 7548,
  SAPB1ChequePaymentUnderCollectionGL = 7550,
  SAPB1SalesOrderSeries = 7564,
  SAPB1CustomerRequestSeries = 7772,
  SAPB1CustomerOwnerCodeSeries = 7774,

  SAPB1UnloadRequestSeries = 7558,
  ActionOnApprovingRebate = 7605,
  VoucherTypeID = 7606,
  ReserveTransOnApproval = 7545,
  HEREMapsAppID = 7608,
  HEREMapsAppCode = 7609,
  FinishAllMandatoryStepsToFinishVisit = 7080,
  BlockCustomerAfterGoodReturns = 7610,
  RequirePhotoForDamagedOrExpiredReturn = 7607,
  EnableCheckingOnNTN = 7611,
  CreditCardBusinessTransaction = 7612,
  EnableMultiSubnetFailover = 7613,
  EnterOdometerOnDayOpenAndClose = 7615,
  OnlineTransactionsValidation = 7596,
  CreditCheckScreenDuteDateAsRemainingDays = 7604,
  ShowNotSoldMSLWarning = 7586,
  SMSWebServiceAccountID = 7617,
  SMSWebServicePassword = 7618,
  SMSWebServiceSecretKey = 7619,
  RecommenededPLConditionType = 7620,
  RecommenededPLConditionTable = 7621,
  UploadPresalesPromotions = 7622,
  DebugEnabled = 7632,
  DebugProcesses = 7633,
  ARCreditMemoTrxTypeName = 7644,
  ARDebitMemoTrxTypeName = 7645,
  Freeitemcostcalc = 7353,
  LevelOEnablingLoggingSystem = 7626,
  AllowTrxOutOfActiveTripDate = 7648,
  GetBranchWHStock = 7657,
  RequestItemsMoreThanStock = 7658,
  EnableStorageItemNotification = 7659,
  RouteOrigin_Destination = 7640,
  EnableSyncDuringLoadReq = 7660,

  ValidateLoadRequestVSReplenishmentTemplate = 7643,

  NBSCalculationPeriod = 7661,
  NBSDim1 = 7662,
  NBSDim2 = 7663,

  EnableAutoArrival = 7634,
  MaximumTransitSpeed = 7635,
  MinimumStopTime = 7636,
  EnableAutoDeparture = 7637,
  AutoDepartureMinutes = 7638,
  UseVisitNextStopScreen = 7639,
  VariableServiceTimeUOM = 7641,
  AllowFinishingBranchVisitsWithUnfinishedTasks = 7642,
  EnableAnyCustomerAutoArival = 7646,
  ShowCommissionInDashboard = 7603,
  EnableCheckFakeGPS = 7653,
  MixMatchNotMainGroupsLimitOutcomeRepeats = 7655,
  MixMatchDiscountApplyOnAchievedRepeats = 7656,
  CalculatePromosTaxesPricesByInvoiceAccount = 7624,
  CalculateSalesQuotaByInvoiceAccount = 8384,
  EnableMaxSalesQuotaCheck = 8390,
  EnableVisitFrequencyRecommendation = 7664,
  RecommendedFrequencyNoOfWeeks = 7665,

  PresaleStockStorageLocations = 7669,
  IncludePromotionsInTargetsCalculation = 7670,
  OnlyWholeRepeatsForDiscountValueAndPoints = 7676,
  SAPB1CustomizationKey = 7678,
  DefaultNegativeReasonID = 7679,
  CreateSalesBillingReferenceTo = 7682,

  ExcludeAXPreSalesReturnsfromUploadToBO = 7686,
  SAP_S_4_Hana = 7688,
  ViewNotesOnPublic = 7689,
  StaffMapping = 7700,
  HelpersFilter = 7701,

  SynchronizeOrdersWithSAP = 7704,

  HideCheckJournalsFromSettelementScreen = 7708,

  TwixUrl = 7711,

  FinishInRouteFirst = 7692,
  DisableOutOfVisitSalesmanCollection = 7668,
  MinMSLScore = 7683,
  MaxNoOfMSLStrikes = 7684,
  InvoiceSkipReasonForBelowMSL = 7685,
  AllowOverandUnderReceiveinDispatching = 7703,

  OnlinePictureResolutionWidth = 7718,
  OnlinePictureResolutionHeight = 7719,



  CustomerDailyInvoicesLimit = 7724,
  AllowSkippingVisits = 7725,
  RestrictSyncByDeviceID = 7743,
  SalesmanEventFrequency = 7742,
  RequireAssetDefinedOnInstallation = 7730,
  RequireAssetSerialAndBarcode = 7731,


  WindowsMobileWillNotBeSupported = 7728,


  SalesmanAllowedOrderStatustoView = 7727,
  OnlineCollectionfromsalesmanJournal = 7748,
  ComunicationsHubUrl = 7735,


  TeleSalesSalesmanCategory = 7746,
  AllowCloseSplittedOrder = 7758,
  AssignFirstAssetOnInstallationTask = 7775,
  AllowPartialCollection = 7792,
  HighlightMSLAlternativeItem = 7803,

  //===//
  PreSalesOnlineStockChecks = 7761,
  SplitExternalAppCustomerNo = 7764,
  AllowPushCustomerDataToGenSys = 7766,
  OnlineReport_client_id = 7780,
  OnlineReport_Username = 7781,
  OnlineReport_Password = 7782,
  OnlineReport_Scope = 7783,
  OnlineReport_ProjectID = 7784,
  DisplayFilterWithRelatedData = 7785,
  SalesmenCategoryEnabledCustomerDailyLimits = 7789,
  NoChangeToReturnApprovalStatus = 7790,
  DisplayLastPrice = 7791,
  UseContainsForOrderScreenAttrFilter = 7794,
  OrderScreenShowExtraLineInfo = 7795,
  MinPriceList = 7796,
  OrderScreenItemIDFilterMethod = 7799,
  FilterOnlineReturnBatches = 7786,
  sumInvoiceAccountBalanceFromChildren = 7800,
  PrintingDayClosingPreview = 7802,
  AutomaticReturnSoldtoParty = 7835,
  EmptiesConditionTypePricing = 7836,


  /// <summary>
  /// //
  /// </summary>
  SAPFawryDocumentType = 7832,
  SAPFawryOffsetGLAccount = 7833,
  SAPShippingCondition = 7828,
  MapReturnBinLocation = 7829,
  SAPIntegrateRebatesAsCreditMemo = 7830,
  PreventPrePaymentWithOpenInvoices = 7816,
  DefaultPortfolioNumber = 7811,
  SAPPreciseAmountOperation = 7806,
  SAPPaymentOffsetAccountType = 7807,
  SAPPaymentOffsetGLAccount = 7808,
  SAPIntegratedPaymentTypes = 7809,
  AllocationOrderDocumentType = 7804,
  SAPIntegrationMode = 7736,
  GetPlantStockBAPIName = 7737,
  ValuationCategory = 7738,
  SparePartFilter = 7740,
  EquipmentType = 7729,
  SalesmanTypeMapping = 7732,
  WorkOrderTypeCategory = 7733,
  SalesmanERPReferenceMapping = 7726,
  Helper2PartnerFunction = 7720,
  Helper3PartnerFunction = 7721,
  UploadStaffInfoInVanCycle = 7722,
  PostGoodIssueforUnloadOrder = 7723,
  ShortageInvoiceDocumentType = 7713,
  RouteMapping = 7714,
  SubDealerSurveyID = 7715,
  BillToPartnerFunction = 7716,
  GlassAndShellHandling = 7709,
  AutomaticReturnDocType = 7710,
  DeliveredQtyChangesMapping = 7705,
  HelperPartnerFunction = 7706,
  SBPartnerFunctionMappingInDispatching = 7707,
  EnableMultipleCreditSegmentMapping = 7699,
  DriverEmployeePartnerFunction = 7770,
  ValidateOnOrderTotalsInDelivery = 7756,
  MaxNumberOfInstallationOrders = 7744,
  WorkOrderTypeInitial = 7739,

  DefaultBankForBankTransfers = 7831,
  PrerouteVisitToOpenDaySalesmanTypes = 7838,
  ShowAvailablePromotionsInOrderScreen = 7839,
  AvailablePromotionsInOrderScreenFilters = 7840,
  FactSheetFreeGoodsDocumentType = 7847,
  CDAFreeGoodsDocumentType = 7848,

  MEMOrderTypeForInstallation = 7823,
  MEMOrderTypeForDismantling = 7824,
  MEMDistributionChannel = 7825,
  MEMSalesDivision = 7826,
  MEMItemCategory = 7827,

  IgnoreReceiptBillTo = 7760,
  UploadJournalsAfterSalesmanSettlement = 7837,
  AllowChangeAssignedEmployees = 7844,
  AllowChangeSyncURLs = 7845,
  UploadJournalsWithSettlementTransactionDate = 7856,
  WorkFlowURL = 7858,
  InternalWorkFlowURL = 7870,
  AdvancedWorkFlow = 7857,
  CDA_DiscountGrpAttribute = 7849,
  CDA_PackageItemAttribute = 7850,
  CDARawCasesUOM = 7863,
  ExcludeFromStrikesCustomerAttrID = 7860,
  ExcludeFromStrikesCustomerAttrVals = 7861,
  DriversAutoSettleDeliveryWithReturn = 7862,
  IndustryAddon = 7869,

  WorkFlowAdminUser = 7866,
  WorkFlowLicKey = 7867,
  //CR 36922
  ExternalAppUrl = 7751,
  ExternalAppUsername = 7752,
  ExternalAppPassword = 7753,
  ExternalAppVisitStepName = 7754,
  ExternalAppVisitStepName2 = 7755,
  SaveAhievedQtyForMixMatchPromo = 7868,
  FilterCusromersByDefaultTerritoryOrRoute = 7871,

  EnableOrderPromoFilter = 7813,
  EnableOrderPromoFilterLog = 7814,

  ForceEnterExpiryDatesOnStockCheck = 7890,
  AvailableAmountToCloseTrip = 7899,
  CreditLimitDim = 7801,
  EpaymentCustomerAttr = 7909,
  TakeBOOrderNoinRoadNetIntegrtaion = 7897,
  SupervisorNotifySalesmanPhotoAPI = 7898,
  PromoInvoiceTotalCalcMode = 7901,
  OrderScreenAvailablePromoDialogOptions = 7900,
  SeparateInvoiceForTaxableItems = 7914,
  ValidateOnDefaultCustomer = 7843,

  OTPRequestURL = 7921,
  OTPTypesAttrID = 7941,
  MaxValueForcingCheckDueToday = 7942,
  EnableOfflineOTP = 7923,
  DefaultADDomain = 7947,
  AllowAddingMultiItemsWithSameBarcode = 7966,
  ScreenReportsToReadFromReportsConnection = 7980,
  ADAuthenticatedUserName = 7983,
  ADAuthenticatedUserPassword = 7984,
  TimeZoneDiffrenceTobeAdded = 7996,
  EnablePrintingShortageInvoiceInDayClosing = 7999,
  EnablePrintingExcessInDayClosing = 8000,
  AutomaticAllocateReturnOnTheVanSalesman = 7991,
  EnableReturnBudgetPcts = 7985,
  EnableItemPriceOverride = 7759,
  EditPriceMinPricePCT = 7946,
  EnableShowConsumerPrice = 8003,
  UploadPaymentOfCreditInvoicesWithoutSettlement = 7995,
  OTPCustomerCategories = 8005,
  NewCustomerRequestType = 8006,
  NewCustomerRequestPhoneSerial = 8007,
  SAPFAWRYReceiptTransactionNumber = 8014,
  SAPFAWRYPaymentTransactionNumber = 8015,
  SAPFAWRYAccount = 8016,
  ReplacementReasonCode = 8033,
  TempCreditItemsCriteria = 8035,
  RecommendedQtyIncreasePCT = 8025,
  RecommendedQtyIncreasePctFor0Stock = 8026,
  RecentWeeksCountForRecommendedQtyCalculation = 8027,
  ExcludeFromStockCountAttrID = 8017,
  Use2StepLoadRequestApproval = 8022,
  CannotExceedRecommnededQtyInOrder = 8013,
  OnlineValidateItemPerInvoicePerPeriod = 8019,
  AddEndDateToPrice = 7952,
  RequireCheckPhoto = 8037,
  AllowReturnPaymentMethodSelection = 7978,
  TempCreditOpenOrdersTotalAttrID = 8012,
  ValidateExceedStandardTemplateOnTransfer = 8004,
  BreakDownUploadedTaxes = 8036,
  SMSProvider = 8040,
  CalculatePromotionsOnShortageInvoice = 8043,
  DonotExceedStockInVerifyStock = 8051,
  InvoiceEmailTemplate = 8058,
  Activate2tripsperSalesman = 8028,
  IdleNumberOfDaysBeforeTermination = 8049,
  DormantUserTemplateID = 8063,
  NumberOfAllowedDormantDays = 8070,
  JournalTypeForReverseOrder = 7924,
  AssignCustomerDefaultSalesmanOnDriverInvoices = 7925,
  AllowPostWithoutLines = 7986,
  SplitOrdersAccordingtoBrand = 8073,
  ExcludeFreeItemPromotionsFromOnlineReturn = 8074,
  AllowMultipleOrdersInVisitStep = 7967,
  DisableOrEnableOrderMultiPaymentMethods = 7965,
  AllowChangingLanguagee = 7990,
  SplitBundleMixMatchOutcomeByAchievedValue = 8077,
  UnloadDamagedtoReturnWarehouse = 8080,
  FIFOReturnMode = 8087,
  WalletRegisterationCode = 7919,
  RebatesTaxesPercentage = 8044,
  RebatesTaxesJournalType = 8045,
  RebatesTaxesIncluded = 8104,
  SellerTradeName = 8081,
  ZatcaSellerID = 8091,
  ZatcaSellerAddress = 8092,
  VatSchemeID = 8093,
  VatSchemeValue = 8094,
  ZatcaURL = 8095,
  ZatcaClearanceInvoice = 8096,
  SellerVATRegistrationNumber = 7915,

  IgnoreSerialsWithOnlineReturn = 8125,
  CheckAllSalesmenHaveActiveTripForLoadRequests = 8120,
  CheckAllSupervisorapproveTransfers = 8119,

  ItemAttrForFastVehicleLoading = 8121,
  InvoicingNotLoadOutstandingDocuments = 8141,
  HidePromotionReport = 8134,
  HidePrintOrderForPreSales = 8135,
  DownloadPresaleStockasATPA = 8085,
  ValidateOrderLimits = 8112,
  ValidateOrderLimitsOnPDAPresales = 8136,
  ValidateOrderLimitsOnPDADelivery = 8137,
  ValidateOrderVolumeLimitUOM = 8113,
  ValidateOrderValueLimitOnNetTotal = 8114,
  PreventUpdatesOnCreditHoldOrders = 8146,
  HideSerialInAssetCheck = 8139,
  HideBarcodeInAssetCheck = 8140,
  MandatoryReasonsInAssetCheck = 8138,
  IgnoreVisitCountInRecommendationCalc = 8147,
  DistributeRebateOutcomeOnChild = 8115,
  DisableOrderNoSequenceForVanSales = 8148,
  NoOfDisplayedMeasureActivities = 8149,
  ValidateInvoiceAccountCreditLimitOnline = 8157,
  DisplayLargeAndSmallUomByDefault = 8158,
  TripsCount = 8153,
  EnableCancelOrder = 7672,
  HandlingDamagedExpiredShortage = 8162,
  BadShortagePrefix = 8163,
  ExpiryDamagedShortagePenaltyJournalType = 8164,
  ExpiryShortageIssueInventoryTransactionType = 8165,
  MaxNumberOfRefundsPerDay = 8117,
  PreventReLoadingTRXForVanSalesmanOnSameTrip = 7979,
  HideClosedAndCancelledTrx = 7998,
  SerialPrefix = 8131,
  AccrualPlantNo = 8129,
  SAPProfitCenter = 7327,
  AllowOutOfRouteVisitsCustomerAttrID = 8168,
  AllowOutOfRouteVisitsCustomerAttrValues = 8169,
  MapShortageInvoiceBinLocation = 8379,
  AllowVerifyStockOnTwoSteps = 8370,
  MinRevenuePriceList = 8378,
  DamagedWarehouseKeeperRole = 7888,
  AllowManualFreeItems = 8381,
  MaxOrderPromotionsPercentage = 8362,
  MaxOrderPromotionsPercentageError = 8363,
  OverrideMaxOrderPromotionsPercentageErrorAttr = 8364,
  ExcludeFromMaxOrderPromotionsPercentage = 8365,
  UploadSalesbuzzPromotionsOnly = 8394,
  AvoidPONumberRepetitionPerCustomer = 8408,
  DisplayItemPhotoinPDAInvoiceScreen = 8413,
  AllowMultiRebateFreeGoodWithSameInvoice = 8411,
  OnlineValidationOnOutstandingDocuments = 8415,
  CashierApprovedAmountVariance = 8429
}
